<template>
  <div class="required-login-block">
    <div class="bg-blur" @click="close()" />

    <div class="main-container" :class="{ 'main-container__dark': isDark() }">
      <div class="content-items">
        <div class="app-logo-wrapper">
          <svg
            width="50"
            height="34"
            viewBox="0 0 50 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.6841 10.2096L8.74674 18.6098H14.6867L11.6841 10.2096ZM1.50131 28.9486L10.0522 5.42786H13.4465L21.9974 28.9486H18.342L15.8616 21.9699H7.5718L5.22193 28.4963L5.09138 28.9486H1.50131ZM0 33.0841H23.107V0H0V33.0841ZM23.7598 33.0841H26.2402V0H23.7598V33.0841ZM42.5587 23.5854C43.9948 22.1638 44.7128 20.096 44.7128 17.2529C44.7128 15.8959 44.4517 14.6035 43.9948 13.4404C43.4726 12.2773 42.8198 11.3727 41.906 10.5973C41.2533 10.0157 40.5352 9.628 39.6867 9.36953C38.8381 9.17568 37.5326 9.04644 35.9008 9.04644H32.4413V25.7824H36.423C39.1645 25.7824 41.1227 25.0716 42.5587 23.5854ZM48.2376 17.3821C48.2376 19.3852 47.846 21.3238 46.9974 23.0038C46.2141 24.6839 45.0392 26.1054 43.4726 27.1393C42.4935 27.8501 41.3838 28.3671 40.2089 28.6255C39.0339 28.9486 37.2715 29.0778 34.9869 29.0778H28.9817V6.33251V5.75095H35.9661C37.7285 5.75095 39.295 5.9448 40.5352 6.26789C41.7755 6.6556 42.9504 7.23715 43.9295 8.01256C45.3003 9.11106 46.3446 10.5326 47.0627 12.1481C47.846 13.7635 48.2376 15.5082 48.2376 17.3821ZM50 0H26.893V33.0841H50V0Z"
              fill="#6998AE"
            />
          </svg>
        </div>
        <div>
          <div v-if="!isDesktop()" class="title">
            {{ $vueTranslate('shared.required_login_title') }}
          </div>
          <div class="description">
            {{ $vueTranslate('shared.required_login') }}
          </div>
        </div>

        <CloseIconComponent
          class="close-icon"
          :theme="theme"
          color="#8F8A9B"
          @click="close()"
        />
      </div>
      <div class="get-app-button" @click="openLink(getLink())">
        {{ getButtonName() }}
      </div>

      <div
        v-if="isDesktop()"
        class="get-app-button sign-up-button"
        @click="openSignUp()"
      >
        {{ $vueTranslate('shared.signup_btn') }}
      </div>
    </div>
  </div>
</template>

<script>
import { EMITTERS } from '../utils/emitters'
import CloseIconComponent from '../../shared/components/icons/Close'
import { THEMES } from '../utils/view_options'

export default {
  name: 'RequiredLoginPopUp',
  components: { CloseIconComponent },
  props: {
    theme: {
      default: THEMES.DARK,
      required: false,
      type: String, // THEMES.DARK | THEMES.LIGHT,
    },
    entity: {
      default: () => null,
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      THEMES,
      signUpLink: '',
      loginInLink: '',
    }
  },
  computed: {
    iosUrl() {
      return this.optional_params.ios_url
    },
    androidUrl() {
      return this.optional_params.android_url
    },
    loginPath() {
      return this.optional_params.login_path
    },
    signUpPath() {
      return this.optional_params.signup_path
    },
  },
  methods: {
    isDark() {
      return this.theme === THEMES.DARK
    },
    isAndroid() {
      return /Android/i.test(navigator.userAgent)
    },
    isIOS() {
      return /iPhone|iPad/i.test(navigator.userAgent)
    },
    isDesktop() {
      return !this.isAndroid() && !this.isIOS()
    },
    getButtonName() {
      return this.isDesktop()
        ? this.$vueTranslate('shared.login_btn')
        : this.$vueTranslate('shared.download_now_btn')
    },
    openLink(link) {
      window.open(link, '_blank').focus()
      this.closeModal()
    },
    openSignUp() {
      const signUpPath = this.getLoginPathWithModal(this.signUpPath)
      this.openLink(signUpPath)
    },
    getLink() {
      if (this.isDesktop()) return this.getLoginPathWithModal(this.loginPath)

      return this.isAndroid() ? this.androidUrl : this.iosUrl
    },
    getLoginPathWithModal(path) {
      const url = new URL(path, window.location.origin)
      let returnTo

      if (window.location.hash) {
        const hash = window.location.hash.slice(1)
        const [path, queryString] = hash.split('?')

        const query = new URLSearchParams(queryString || '')
        const id = this.entity?.ebook_id || this.entity?.id
        query.set('showModal', id)

        const newHash = `${path}?${query.toString()}`
        returnTo = `${window.location.origin}${window.location.pathname}#${newHash}`
      } else {
        const baseUrl = new URL(window.location.href)
        const id = this.entity?.ebook_id || this.entity?.id
        baseUrl.searchParams.set('showModal', id)

        returnTo = baseUrl.toString()
      }

      url.searchParams.set('return_to', returnTo)
      return url.toString()
    },
    close() {
      this.$emit(EMITTERS.AUTHORIZATION_CLOSE_MODAL)
    },
  },
}
</script>

<style lang="scss">
.bg-blur {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #323232;
  opacity: 0.9;
  z-index: 9999;
}

.required-login-block {
  display: flex;
  justify-content: center;
  position: fixed;
  top: 40%;
  left: 0;
  z-index: 100000;
  width: 100%;

  .main-container {
    display: flex;
    gap: 15px;
    position: relative;
    justify-content: center;
    background: white;
    z-index: 10000;
    width: 500px;
    padding: 24px;
    border-radius: 8px;
    flex-direction: column;
  }

  .content-items {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    gap: 16px;
  }

  .title {
    font-weight: 700;
    font-size: 18px;
    font-family: 'DM Sans', sans-serif;
    padding-right: 10px;
    margin-bottom: 5px;
  }

  .description {
    font-size: 14px;
    padding-right: 10px;
  }

  .get-app-button {
    background: #6998ae;
    display: block;
    border-radius: 6px;
    color: #fff;
    font-size: 18px;
    padding: 10px 0;
    text-align: center;
    margin-top: 20px;
    cursor: pointer;
  }

  .sign-up-button {
    color: #6998ae !important;
    background: #fff !important;

    margin-top: 0 !important;
    border: 1px solid;
  }
}

.main-container__dark {
  background: #32303c !important;
  color: white;
}
</style>
